import * as React from 'react';
import { Paging } from './paging';
import { PagingArrows } from './paging-arrows';
interface IPaginationProps {
    pagination: IPaginationOptions;
    onPageSelect(page: number): void;
}

export interface IPaginationOptions {
    items: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
}


/// <summary>
/// Renders pagination arrows and buttons
/// </summary>
export class Pagination extends React.Component<IPaginationProps, any> {
    render() {
        return (
            <div className="pagination-container">
                <PagingArrows paging={this.props.pagination} isLeftArrows={true} onPageSelect={this.props.onPageSelect} />

                {/* Separate components for mobile and desktop pagination due to differing numbers of page buttons on each view*/}
                <div className="pagination-desktop">
                    <Paging paging={this.props.pagination} onPageSelect={this.props.onPageSelect} numberOfButtonsToShow={8} />
                </div>

                <div className="pagination-mobile">
                    <Paging paging={this.props.pagination} onPageSelect={this.props.onPageSelect} numberOfButtonsToShow={6} />
                </div>

                <PagingArrows paging={this.props.pagination} isLeftArrows={false} onPageSelect={this.props.onPageSelect} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/components/pagination/pagination.tsx